import { render, staticRenderFns } from "./ModalOnGoing.vue?vue&type=template&id=2af39550&"
import script from "./ModalOnGoing.vue?vue&type=script&lang=js&"
export * from "./ModalOnGoing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports